import React from 'react';
import { RegularButton, Typography } from 'fronton-react';
import clsx from 'clsx';
import { capitalize } from 'utils/capitalize';
import { ProductSuggestion } from 'types/suggestions';
import { SuggestionsGaMetaInfo } from '../searchbar-old/types';
import { suggestion, suggestionButton, suggestionText } from '../searchbar-old/styles';

export interface SuggestionListItemProductProps {
  elementIndex: number;
  navigationIndex: number;
  suggestionSelector: string;
  isSrp: boolean;
  productSuggestion: ProductSuggestion;
  searchHref: string;
  buttonAction: (
    id: number,
    linkToNavigate?: string,
    gaMeta?: SuggestionsGaMetaInfo
  ) => React.HTMLAttributes<HTMLButtonElement>;
}

export const SuggestionListItemProduct = (props: SuggestionListItemProductProps) => {
  const {
    elementIndex,
    navigationIndex,
    suggestionSelector,
    isSrp,
    productSuggestion,
    searchHref,
    buttonAction,
  } = props;
  const { phrase, id } = productSuggestion;

  const link = `${searchHref}?q=${phrase}&suggest=true`;

  return (
    <div
      key={id}
      role="option"
      id={id}
      aria-selected={elementIndex === navigationIndex}
      data-qa-header-search-suggestion="">
      <RegularButton
        variant="pseudo"
        tabIndex={-1}
        withExtraClickZone
        className={clsx(suggestionSelector, suggestion, {
          active: elementIndex === navigationIndex,
          [suggestionButton]: isSrp,
        })}
        key={id}
        data-qa="suggestion-button"
        {...buttonAction(elementIndex, isSrp ? link : undefined, {
          block: 'Товары',
          index: elementIndex,
          text: phrase,
        })}
        {...(!isSrp && { href: link })}>
        <Typography variant="m" size="body_long" className={suggestionText}>
          {capitalize(phrase)}
        </Typography>
      </RegularButton>
    </div>
  );
};
